var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16.8256 9.88401L16.3023 13.0439H13.7442V21H9.90698V13.0439H7V9.88401H9.90698V7.40125C9.90698 4.57994 11.7674 3 14.4419 3C15.2558 3 16.186 3.11285 17 3.22571V6.10345H15.4884C14.093 6.10345 13.7442 6.78056 13.7442 7.68339V9.88401H16.8256Z","fill":"currentColor"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
